import { MascotBubble } from '@tankef/ui';

import type { StepType } from '@reactour/tour';

export const TANDAS_TOUR_ID = 'tandas';

export const tandasSteps: StepType[] = [
  {
    selector: '[data-tour="tandas-balance"]',
    position: 'bottom',
    content: (
      <MascotBubble emotion="happy" size="sm" direction="right" showPointer={false}>
        Aquí ves el <strong>resumen de tus tandas</strong>: cuánto has ahorrado y cuándo es tu
        próximo turno de cobrar.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="tandas-new-btn"]',
    position: 'left',
    content: (
      <MascotBubble emotion="celebrating" size="sm" direction="right" showPointer={false}>
        ¿Lista para ahorrar en grupo? Toca aquí para <strong>crear una nueva tanda</strong> o unirte
        a una existente.
      </MascotBubble>
    ),
  },
  {
    selector: '[data-tour="tandas-table"]',
    position: 'top',
    content: (
      <MascotBubble emotion="neutral" size="sm" direction="right" showPointer={false}>
        Tus <strong>tandas activas</strong>. Toca una para ver tu turno, los participantes y el
        historial de pagos.
      </MascotBubble>
    ),
  },
];
